import styled from "styled-components";

export default function DividerWithLabel({ label }: any) {
  return (
    <SDividerWithLabel>
      <SDividerLineContainer aria-hidden="true">
        <SDividerLine />
      </SDividerLineContainer>
      <SLabelContainer>
        <SLabel>{label}</SLabel>
      </SLabelContainer>
    </SDividerWithLabel>
  );
}

const SDividerWithLabel = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SDividerLineContainer = styled.div`
  width: 100%;
  position: absolute;
  display: flex;
  align-items: center;
`;

const SDividerLine = styled.div`
  width: 100%;
  border-top: 1px solid #d1d5db;
`;

const SLabelContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const SLabel = styled.span`
  padding: 0 8px;
  color: #9ca3af;
  background-color: white;
  font-size: 14px;
`;
